import { useCallback } from 'react';
import useWfApi from './axios/useWfApi';
import { WfProduct, WfProductDetails } from '../models/WfProduct';

export interface WfProductParams {
  branchCode: string;
  customerId: string;
  disasterId: string;
}

export interface WfProductDetailsParams {
  branchCode: string;
  disasterId: string;
  productNumber: string;
}

function useWfProductRepo() {
  const { get } = useWfApi();

  const getProductsRequest = useCallback(
    async (parameters: WfProductParams) => {
      try {
        return (
          (await get<WfProduct[]>('/api/wf/product', {
            params: parameters,
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
          })) ?? []
        );
      } catch (error) {
        console.log(error);
        return [];
      }
    },
    [get]
  );

  const getProductDetailsRequest = useCallback(
    async (parameters: WfProductDetailsParams) => {
      try {
        return (
          (await get<WfProductDetails>('/api/wf/product/detail', {
            params: parameters,
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
          })) ?? null
        );
      } catch (error) {
        console.log(error);
        return null;
      }
    },
    [get]
  );

  return {
    getProductsRequest,
    getProductDetailsRequest,
  };
}

export default useWfProductRepo;
